var address = {};
module['exports'] = address;
address.county = require("./county");
address.default_country = require("./default_country");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_IE/address/index.js
// module id = 1022
// module chunks = 0